import React, { useMemo, CSSProperties } from 'react'
import { Select } from 'antd'
import styled from '@emotion/styled'

import Text from './Text'
import { useCallback } from 'react'

const SelectContainer = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
  }
`
const StyledSelect = styled(Select)`
  width: 100%;
`

export type BaseSelectProps = {
  options: { label: string; value: string | number }[]
  placeholder?: string
  value?: string | number | undefined
  onSelect?: any
  onChange?: any
  disabled?: boolean
  style?: CSSProperties
  defaultValue?: string | number
}
const BaseSelect = (props: BaseSelectProps) => {
  const { options, placeholder, value, onChange, onSelect, disabled = false, style, defaultValue } = props

  const handleChange = useCallback(
    (value) => {
      onChange && onChange(value)
    },
    [onChange],
  )
  const placeholderNode = useMemo(() => {
    return (
      <Text size={18} color="#bfbfbf">
        {placeholder}
      </Text>
    )
  }, [placeholder])
  return (
    <SelectContainer
      style={style}
    >
      <StyledSelect
        onChange={handleChange}
        placeholder={placeholderNode}
        value={value}
        size="large"
        onSelect={onSelect ? onSelect : null}
        disabled={disabled}
        defaultValue={defaultValue}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            <Text size={18} type="Medium">
              {option.label}
            </Text>
          </Select.Option>
        ))}
      </StyledSelect>
    </SelectContainer>
  )
}

export default BaseSelect
